import {Component, OnInit} from '@angular/core';
import {AlertModule} from 'ngx-bootstrap/alert';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {BsModalRef, ModalModule} from 'ngx-bootstrap/modal';
import {TimepickerModule} from 'ngx-bootstrap/timepicker';
import {Subject} from 'rxjs';

@Component({
    selector: 'app-modal-component',
    templateUrl: './modal-app-version.component.html',
    styleUrls: ['./modal-app-version.component.scss',
    ]
})
export class ModalAppVersionComponent implements OnInit {
    onClose: Subject<boolean>;
    closeBtnName = 'Reload';
    title = 'System Notification';
    liveVersion;

    constructor(
        public bsModalRef: BsModalRef
    ) {
        this.onClose = new Subject();
    }

    ngOnInit() {
        // placeholder
    }

    public onConfirm(): void {
        this.onClose.next(true);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    public hideConfirmationModal(): void {
        this.onClose.next(null);
        this.bsModalRef.hide();
    }
}
